import type { SelectAsync, SelectAsyncCreatable, SelectAsyncProps } from '@ztechapps/webui.input'
import type { ProductTypeEnum } from '@ztechapps/common.contract'

export enum ProductSelectSearchType {
  PartialSearch = 1,
  FullTextSearch = 2,
  Default = 3, //which is similar tot he partial search
}

export type ProductSelectProps = SelectAsyncProps & {
  filter?: Record<any, any>
  defaultProductType?: ProductTypeEnum | 'All'
  compact?: boolean
  As?: typeof SelectAsyncCreatable | typeof SelectAsync
}
